import { Close, QuestionMark } from '@mui/icons-material';
import {
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  styled,
  useTheme,
} from '@mui/material';
import { I24Support, LampCharge, Sms } from 'iconsax-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../Hooks/useConfig';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const IconButtonCustom = styled(IconButton)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? theme.palette.secondary.secondary_60
      : theme.palette.secondary.secondary_30,
  width: theme.spacing(8),
  height: theme.spacing(8),
  transition: 'opacity 0.2s linear',
  color:
    theme.palette.mode === 'dark'
      ? theme.palette.secondary.secondary_10
      : '#fff',
  '&:hover': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? theme.palette.secondary.secondary_70
        : theme.palette.secondary.secondary_40,
    opacity: '0.8',
  },
  [theme.breakpoints.down('md')]: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));
const ContainerMenuHelp = styled(Box)(({ theme }) => ({
  position: 'fixed',
  right: theme.spacing(8),
  bottom: theme.spacing(6),
  zIndex: 9999,

  [theme.breakpoints.down('xl')]: {
    right: theme.spacing(6),
    bottom: theme.spacing(6),
  },

  [theme.breakpoints.down('md')]: {
    right: theme.spacing(5),
    bottom: theme.spacing(2.5),
  },
}));

const CustomMenu = styled(Menu)(({ theme }) => ({
  '.MuiPaper-root': {
    borderRadius: theme.spacing(4),
    padding: theme.spacing(4, 0),
    border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.secondary.neutral_50 : theme.palette.secondary.neutral_80}`,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? theme.palette.secondary.surface_11
        : '#FFF',
  },
  '.MuiList-root': {
    padding: '0',
  },
  '.MuiMenuItem-root': {
    gap: theme.spacing(2),
    padding: '0',
  },
  '.MuiListItemIcon-root': {
    minWidth: 'auto',
  },
}));
const Discord = styled('img')(({ theme }) => ({
  width: theme.spacing(4),
}));
const LinkItem = styled('a')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  color: theme.palette.primary.main,
  padding: theme.spacing(1.5, 4),
  '.MuiListItemIcon-root': {
    minWidth: 'auto',
  },
}));

const MenuHelp = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const { t } = useTranslation();
  const { contactUsUrl } = useConfig();
  const location = useLocation(); // Add this hook

  // Check if current path includes either "/stepper" or "/verify-email"
  if (
    location.pathname.includes('/stepper') ||
    location.pathname.includes('/verify-email')
  ) {
    return null; // Don't render the component on these routes
  }

  const handleClick = (event) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <ContainerMenuHelp>
      <IconButtonCustom
        onClick={handleClick}
        size="small"
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        className="menu-help"
      >
        {anchorEl ? (
          <Close fontSize={'inherit'} />
        ) : (
          <QuestionMark fontSize={'inherit'} />
        )}
      </IconButtonCustom>
      <CustomMenu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        disableScrollLock={true}
        PaperProps={{
          elevation: 0,
          style: { marginTop: '-10px' },
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
          },
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <MenuItem
          className="chat-button"
          onClick={() => {
            handleClose();
            showChat();
          }}
        >
          <LinkItem>
            <ListItemIcon>
              <I24Support size={'16px'} />
            </ListItemIcon>
            {t('menu_help.online_support')}
          </LinkItem>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <LinkItem target="_blank" href={contactUsUrl}>
            <ListItemIcon>
              <Sms size={'16px'} />
            </ListItemIcon>
            {t('menu_help.contact_us')}
          </LinkItem>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <LinkItem
            target="_blank"
            href="https://magicalapi.canny.io/feature-requests"
          >
            <ListItemIcon>
              <LampCharge size={'16px'} />
            </ListItemIcon>
            {t('menu_help.request_feature')}
          </LinkItem>
        </MenuItem>
      </CustomMenu>
    </ContainerMenuHelp>
  );
};
export default MenuHelp;
